import React from 'react';
import { motion } from 'framer-motion';
const regions = [{
  flag: '🇬🇧',
  title: 'United Kingdom',
  description: 'We work with major UK retail and wholesale groups.',
  retailers: ['Tesco', 'Sainsbury’s', 'Asda', 'Morrisons', 'Aldi UK', 'Lidl UK', 'Co-op', 'Iceland', 'Booker Wholesale', 'Costco UK']
}, {
  flag: '🇪🇺',
  title: 'Europe',
  description: 'Engaging with leading retail and hypermarket groups across the EU.',
  retailers: ['E.Leclerc', 'Carrefour', 'Auchan', 'Intermarché', 'Metro Cash & Carry', 'Spar', 'Lidl', 'Aldi', 'Rewe', 'Edeka', 'Mercadona']
}, {
  flag: '🌏',
  title: 'Asia',
  description: 'Supporting sourcing and market entry in growing Asian markets.',
  retailers: ['Lulu Hypermarket', 'Panda Retail', 'Aeon', 'Reliance Retail', 'Big Bazaar', 'NTUC FairPrice', '7-Eleven']
}];
export function IndustriesSection() {
  return <section id="retail-network" className="py-24 bg-[#1a2d4a] relative" data-id="element-374">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-375">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-376">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-377">
            <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-378">
              Our Retail Network
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-379">
              Trusted by Leading Retail Chains
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-380">
              We work directly with major hypermarkets, supermarket chains, and
              wholesale groups across three continents.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-381">
          {regions.map((region, index) => <motion.div key={region.title} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} whileHover={{
          y: -5
        }} className="bg-[#0a1628] p-8 border border-white/5 hover:border-[#d4a853] transition-all duration-300 flex flex-col h-full" data-id="element-382">
              <div className="text-4xl mb-6" data-id="element-383">{region.flag}</div>

              <h3 className="text-2xl font-bold text-white mb-3" data-id="element-384">
                {region.title}
              </h3>

              <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-385">
                {region.description}
              </p>

              <div className="flex flex-wrap gap-2 mt-auto" data-id="element-386">
                {region.retailers.map((retailer, i) => <span key={i} className="bg-[#1a2d4a] px-3 py-1 text-xs text-gray-300 border border-white/10 rounded-full" data-id="element-387">
                    {retailer}
                  </span>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}